import { fetchWithAuth } from '../auth/fetchWithAuth';
import { notifyError, notifySuccess } from '../components/Toast';

  export const loadEvidences = (evidenceId, processId, user, unidadGestion = null, sede = null) => async (dispatch) => {
    dispatch({ type: 'LOAD_EVIDENCES_REQUEST' });
    
    try {
      const sedeParam = sede === 'ALL' ? '' : (sede || '');
      
      const params = new URLSearchParams({
        unidadGestion: unidadGestion || '',
        sede: sedeParam,
        idEvidencia: evidenceId ? evidenceId : '',
        idProceso: processId ? processId : '',
      }).toString();

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/evidencias?${params}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const documento = await response.json();
        dispatch({ type: 'LOAD_EVIDENCES_SUCCESS', payload:documento });

      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'LOAD_EVIDENCES_FAIL', errorMessage });
      }

    } catch (error) {
      dispatch({ type: 'LOAD_EVIDENCES_FAIL', error });
    }
  };

  export const loadEvidenceById = (evidenceId, user) => async (dispatch) => {
    dispatch({ type: 'LOAD_EVIDENCE_BY_ID_REQUEST' });
    try {
      // Verificar que evidenceId sea válido
      if (!evidenceId) {
        dispatch({ type: 'LOAD_EVIDENCE_BY_ID_FAIL', payload: 'ID de evidencia no válido' });
        notifyError('ID de evidencia no válido');
        return;
      }

      const params = new URLSearchParams({
        unidadGestion: '',
        sede: '',
        idProceso: '',
        idEvidencia: evidenceId,
      }).toString();

      const url = `${process.env.REACT_APP_API_BASE_URL}reportes/evidencias?${params}`;
      // Usamos fetchWithAuth para unificar manejo de auth/errores
      const response = await fetchWithAuth(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
      }, dispatch);

      if (response.ok) {
        const payload = await response.json();

        let evidencia = null;
        if (Array.isArray(payload)) {
          evidencia = payload.find((ev) => String(ev.Id) === String(evidenceId)) || payload[0] || null;
        } else if (payload && typeof payload === 'object') {
          evidencia = payload;
        }

        if (evidencia) {
          dispatch({ type: 'LOAD_EVIDENCE_BY_ID_SUCCESS', payload: evidencia });
        } else {
          dispatch({ type: 'LOAD_EVIDENCE_BY_ID_FAIL', payload: 'Evidencia no encontrada' });
          notifyError('Evidencia no encontrada');
        }
      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'LOAD_EVIDENCE_BY_ID_FAIL', payload: errorMessage });
        notifyError('Error al cargar la evidencia: ' + errorMessage);
      }

    } catch (error) {
      dispatch({ type: 'LOAD_EVIDENCE_BY_ID_FAIL', payload: error.message });
      notifyError('Error al cargar la evidencia: ' + error.message);
    }
  };

  export const loadDocumentoContent = (id,user) => async (dispatch) => {
    dispatch({ type: 'LOAD_DOCUMENTO_CONTENT_REQUEST' });
    
    try {

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/respuestas/archivo/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const documento = await response.json();
        dispatch({ type: 'LOAD_DOCUMENTO_CONTENT_SUCCESS', payload:documento });
        return documento;

      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'LOAD_DOCUMENTO_CONTENT_FAIL', errorMessage });
      }

    } catch (error) {
      dispatch({ type: 'LOAD_DOCUMENTO_CONTENT_FAIL', error });
    }
  };
  
  export const deleteEvidence = (id,user) => {
    return async (dispatch) => {
      dispatch({ type: 'DELETE_EVIDENCES_REQUEST' });
      try {
        const response = await fetchWithAuth(
          `${process.env.REACT_APP_API_BASE_URL}reportes/evidencias/${id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + user.token
            },
          },dispatch
        );
        if (response.ok) {
          dispatch({ type: 'DELETE_EVIDENCES_SUCCESS',payload: id});
          notifySuccess('Se ha eliminado la evidencia correctamente');
        } else {
          const errorMessage = await response.text();
          dispatch({ type: 'DELETE_EVIDENCES_FAIL', payload: errorMessage });
        }
      } catch (error) {
        dispatch({ type: 'DELETE_EVIDENCES_FAIL', payload: error.message });
        notifySuccess('Hubo un error al eliminar la evidencia');
      }
    };
  };
  
  export const saveEvidence = (processId, unitId, sedeId, evidenceData, selectedKpis, file, user, duplicated = false, evidenceId = null) => {
    return async (dispatch) => {
      dispatch({ type: 'SAVE_EVIDENCES_REQUEST' });

      try {
        const archivos = [];
        // Archivo principal: si se cambió, subimos uno nuevo; si no, preservamos Id (sin pedir archivo físico)
        if (file) {
          archivos.push({
            nombre: file.name,
            tipoArchivo: file.type,
            tamanio: `${file.size} bytes`,
            esArchivo: true,
            esPrincipal: true,
          });
        } else if (evidenceData.archivoIdPrincipal) {
          archivos.push({
            Id: evidenceData.archivoIdPrincipal,
            esArchivo: false,
            esPrincipal: true,
          });
        }

        if (evidenceData.anexos && evidenceData.anexos.length > 0) {
          evidenceData.anexos.forEach((anexo) => {
            // Si el anexo ya existe en el backend, preservamos su Id
            const isExisting = Boolean(anexo.archivoId);

            if (anexo.tipo === 'archivo') {
              if (isExisting) {
                archivos.push({
                  Id: anexo.archivoId,
                  nombre: anexo.nombre,
                  esArchivo: false, // existente, no subir archivo físico
                  esPrincipal: false,
                  descripcion: anexo.descripcion,
                });
              } else {
                archivos.push({
                  nombre: anexo.valor.name,
                  tipoArchivo: anexo.valor.type,
                  tamanio: `${anexo.valor.size} bytes`,
                  esArchivo: true,
                  esPrincipal: false,
                  descripcion: anexo.descripcion,
                });
              }
            } else if (anexo.tipo === 'url') {
              const urlObj = {
                ...(isExisting ? { Id: anexo.archivoId } : {}),
                nombre: anexo.valor,
                tipoArchivo: 'url',
                esArchivo: false,
                esPrincipal: false,
                descripcion: anexo.descripcion,
                url: anexo.valor,
              };
              archivos.push(urlObj);
            }
          });
        }

        const evidencia = {
          ...(evidenceId && { Id: evidenceId }), // Solo incluir ID si estamos editando
          titulo: evidenceData.titulo,
          descripcion: evidenceData.descripcion,
          archivos: archivos,
          kpis: selectedKpis.map(kpiId => ({ Id: kpiId })),
          unidadesGestion: [
            {
              codigoUnidadGestion: unitId,
              codigoSede: sedeId //=== 'ALL' ? null : (activePermission?.sede?.codigo|| null)
            }
          ]
        };

        const formData = new FormData();
        formData.append('evidencia', JSON.stringify(evidencia));
        
        if (file) {
          formData.append('archivo', file);
        }
        
        // Agregar archivos de anexos
        if (evidenceData.anexos && evidenceData.anexos.length > 0) {
          evidenceData.anexos.forEach((anexo, index) => {
            // Solo subimos a FormData si es un archivo NUEVO (sin archivoId)
            if (anexo.tipo === 'archivo' && !anexo.archivoId) {
              formData.append(`anexo_${index}`, anexo.valor);
            }
          });
        }

        const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/procesos/${processId}/evidencias`,
          {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + user.token
            },
            body: formData,
          }, dispatch
        );

        if (response.ok) {
          dispatch({ type: 'SAVE_EVIDENCES_SUCCESS' });
          
          let message = evidenceId ? 'Evidencia actualizada exitosamente' : 'Evidencia guardada exitosamente';
          if(duplicated) {
            message = 'Evidencia duplicada exitosamente';
          }

          notifySuccess(message);
          
          if (!duplicated)
            dispatch(loadEvidences(null, processId, user,unitId,sedeId));
          
        } else {
          const errorMessage = await response.text();
          dispatch({ type: 'SAVE_EVIDENCES_FAIL', payload: errorMessage });
          notifyError('Error al guardar la evidencia: ' + errorMessage);
        }

      } catch (error) {
        dispatch({ type: 'SAVE_EVIDENCES_FAIL', payload: error.message });
        notifyError('Error al guardar la evidencia: ' + error.message);
      }
    };
  };
  